import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { StyledElement } from '@ui/types';
import { fixedAtTopCss } from '@styles/css';
import Item from './item';

export type NavBarProps = StyledElement & { fixAtTop?: boolean };

type LayoutProps = FunctionComponent<NavBarProps> & {
  Item: typeof Item;
};

const NavBarContainer = styled.div<NavBarProps>`
  display: flex;
  z-index: 999;
  ${({ fixAtTop }) => fixAtTop && fixedAtTopCss}
`;

// eslint-disable-next-line react/prop-types
const NavBar: LayoutProps = ({ children, ...props }) => {
  return <NavBarContainer {...props}>{children}</NavBarContainer>;
};

NavBar.Item = Item;

export default NavBar;
